<template>

  <div v-if="$store.state.auth.user">

    <div class="ui large breadcrumb">
      <div class="bold section">
        Perfil de {{ $store.state.auth.user.name }}
      </div>
    </div>

    <bookmark-button label="Meu Perfil" />

    <div class="ui divider"></div>

    <div class="ui grid">

      <div class="sixteen wide column">
        <button class="ui button" @click="$refs.updPswModal.show()">
          <i class="lock red icon"></i> Alterar senha
        </button>
        <button class="ui button m-l-10" @click="$refs.updEmailModal.show()">
          <i class="envelope teal icon"></i> Alterar e-mail
        </button>     
      </div>

      <div class="sixteen wide column">
        <div class="ui segment">          
          <div class="ui form">
            <div class="fields">              
              <div class="eight wide field">
                <label class="form-label">Nome <span class="red text">*</span></label>
                <input class="uppercase" v-model="user.name" @blur="user.name = $toUpperCase($event)">
              </div>
              <div class="eight wide field">
                <label class="form-label">Sobrenome <span class="red text">*</span></label>
                <input class="uppercase" v-model="user.lastName" @blur="user.lastName = $toUpperCase($event)">
              </div>
            </div>
            <div class="fields"> 
              <div class="eight wide field">
                <label class="form-label">Perfil</label>
                <input type="email" :value="user.groupName" readonly="readonly">
              </div>             
              <div class="eight wide field">
                <label class="form-label">E-mail</label>
                <input type="email" :value="user.email" readonly="readonly">
              </div>
            </div>
          </div>          
        </div>
      </div>

      <div class="sixteen wide column">        
        <button class="ui blue button" :class="{ disabled: !canUpdate, loading: updating }" 
          @click="onUpdate()">
          <i class="check icon"></i> Atualizar
        </button>        
      </div>

    </div>

    <upd-psw-modal ref="updPswModal" />
    <upd-email-modal ref="updEmailModal" />

  </div>

</template>

<script>

  import BookmarkButton from "@/components/bookmark-button.vue"
  import AuthService from "@/services/auth-service"
  import UpdPswModal from "./upd-psw-modal.vue"
  import UpdEmailModal from "./upd-email-modal.vue"

  export default { 

    name: "ProfilePage",

    data() {
      return {
        updating: false,
        initialName: "",
        user: {},
      }
    },

    components: {
      BookmarkButton,
      UpdPswModal,
      UpdEmailModal,
    },

    watch: {

      "$store.state.auth.user.email" () {
        this.loadUser()
      }
    },

    created() {
      this.loadUser()        
    },

    computed: {

      canUpdate() {
        
        if (!this.initialName || !this.user.name || !this.user.lastName)
          return false

        return (this.initialName != this.user.name + this.user.lastName)   
      },
    },
    
    methods: {

      loadUser() {

        if (!this.$store.state.auth.user)
          return

        const { id, name, lastName, email, groupName } = this.$store.state.auth.user

        this.user = { id, name, lastName, email, groupName }
        this.initialName = name + lastName
      },

      async onUpdate() {

        if (!this.validData())
          return

        this.updating = true
        
        try {

          const { name, lastName } = this.user

          await new AuthService().updateCurrentUser({ name, lastName })
          
          this.$msg.success("Dados atualizados com sucesso")

          this.updating = false
          
        } catch (error) {
          
          this.updating = false
          this.$errorHandler(error)
        }

      },

      validData() {

        let isOk = true
        let message = ""

        if (!this.user.name || !this.user.lastName) {
          message = "Informe seu nome e sobrenome"
        }
        
        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },
    },
  }

</script>

